<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()
const { accidentPredamages } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <div v-if="accidentPredamages.display" class="col-span-12 lg:col-span-6">
    <SectionsDetailsElementsSection>
      <template #heading>
        {{ accidentPredamages.title }}
      </template>

      <template #content>
        <SectionsDetailsElementsParameters
          :parameters="accidentPredamages.elements"
          full-width
        />
      </template>
    </SectionsDetailsElementsSection>
  </div>
</template>
